// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__Vg7j6","cta":"styles_cta__07lT-","content":"styles_content__O0ua9","heading":"styles_heading__MynQC","desc":"styles_desc__TaGSi"};